import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/[locale]/error.tsx");
